import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'
import { languageChange, queryConfigItem } from 'store/siteConfig'

export default function(route) {
  const Main = Loadable({
    loader: () => import('./Main'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          topUpMainState: state.topUpMainState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          languageChange,
          queryConfigItem
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/main`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Main {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
